/** NWS RIDGE II “weather for a location” radar view (loop + map centered on lat/lon). */
export function buildNwsRadarLocationUrl(latitude: number, longitude: number): string {
  const lat = roundCoord(latitude);
  const lon = roundCoord(longitude);
  return `https://radar.weather.gov/location?lat=${lat}&lon=${lon}`;
}

function roundCoord(n: number): number {
  return Math.round(n * 100) / 100;
}
